import React from 'react'
import { Spinner } from '@chakra-ui/react'

export const CenteredSpinner: React.FC = () => (
  <div style={{ textAlign: 'center', padding: '2em' }}>
    <Spinner />
  </div>
)
